// unit_ids[].DefaultValue comes back from the DB as a STRING ("true"/"false"),
// while freshly-edited rows hold a real boolean. A plain truthiness check
// (`u.DefaultValue`) treats the string "false" as true and picks the wrong row.
// Use this helper for EVERY DefaultValue read.
export const isDefaultRow = (u) =>
  u?.DefaultValue === true || u?.DefaultValue === "true";
